import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { ConsentManager } from '../../_services/consent/consent-manager.service';

/**
 * Bandeau de consentement (premier chargement) et fenêtre de choix détaillés
 * (ouverte aussi par le lien « Gérer mes cookies » du pied de page).
 * « Tout refuser » et « Tout accepter » ont exactement le même style et la même taille.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-cookie-consent',
  imports: [A11yModule],
  templateUrl: './cookie-consent.component.html',
})
export class CookieConsentComponent {
  consent = inject(ConsentManager);

  readonly buttonClass =
    'min-w-[10rem] rounded-md border-2 border-primary bg-white px-5 py-2.5 text-sm font-bold text-primary hover:bg-blue-light focus:outline-none focus-visible:ring-4 focus-visible:ring-secondary/50';

  onEscape(): void {
    this.consent.closePreferences();
  }
}
